import Benefits from "../../layouts/home/beneficios";
import Hero from "../../layouts/home/hero";

function Home() {
    return (
        <>
            <Hero/>
            <Benefits/>
        </>
    )
}
export default Home;